/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsConfidenceBuilders = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsConfidenceBuilders = $.extend(this, window.PXUTheme.getSectionData($section));

    this.createSlider();

  },
  createSlider: function() {

    let confidenceBuildersSlider = $('.confidence-builders .slider');

    $(confidenceBuildersSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: false,
      pageDots: false,
      contain: false,
      prevNextButtons: true,
      //prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      watchCSS: true,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(confidenceBuildersSlider).on( 'settle.flickity', function() {
            $(confidenceBuildersSlider).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;